import Spinner from './styled';

export default Spinner;
